/**
 * @fileoverview Landing page section showcasing the performance table.
 * @module features/landing/components/PerformanceTableSection
 */

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { LandingPerformanceTable } from './LandingPerformanceTable'

/**
 * Performance table section for the landing page.
 * Displays a simplified SKU performance table with mock data.
 *
 * @component
 */
export function PerformanceTableSection(): ReactElement {
  const { t } = useTranslation('features-landing')

  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* 70/30 Layout */}
        <div className="flex flex-col lg:flex-row gap-10">
          {/* 70% - Performance Table */}
          <div className="w-full lg:w-[70%] min-w-0">
            <LandingPerformanceTable />
          </div>

          {/* 30% - Section Header */}
          <div className="w-full lg:w-[30%] flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold mb-4 text-foreground">
              {t('performanceTable.title')}
            </h2>
          </div>
        </div>
      </div>
    </section>
  )
}
